module.exports = __webpack_public_path__ + "static/work01_02-c38308a3d6613991d815fa54673a0f6f.jpg";